module.exports = __webpack_public_path__ + "img/bnr-contact-1.3afb18c0.jpg";